import React, { Component } from "react"
import { graphql } from '@apollo/client/react/hoc'
import { HasPermissionsQuery } from "../../Functions/querys"
import WeeklyChargeModal from '../../Material/WeeklyChargeModal'
import RepAssignmentModal from "../../Material/RepAssignmentModal"
import { Popover, PopoverBody } from "reactstrap"
import "./ActionsPopup.css"
import { CurrentUserContext } from '../../Context/CurrentUserContext'
import MassMessageModal from '../../Material/MassMessageModal'
import AddNewDriver from './AddNewDriver'
import gql from 'graphql-tag'
import withApolloClient from '../../withApolloClient'
import ConfirmationPopup from "../../Material/ConfirmationPopup"

const UpdateDriver = gql`
    mutation updateDriverMutation($input: UpdateDriverMutationInput!){
    updateDriver(input:$input){
        ok
    }
} `

const DownloadDriverListMutation = gql`
    mutation downloadDriverList($input: DownloadDriverListInput!) {
        downloadDriverList(input: $input) {
            ok
            errors {
                messages
            }
        }
    }
`

const RemoveDriverAssignmentMutation = gql`
    mutation RemoveDriverAssignment($input: RemoveDriverAssignmentInput!) {
        removeDriverAssignment(input: $input) {
            ok
            errors {
                messages
            }
        }
    }
`
const runDriverBulkActionMutation = gql`
 mutation runDriverBulkActionMutation($input: RunDriverBulkActionMutationInput!) {
        runDriverBulkActionMutation(input: $input) {
            ok
            errors {
                messages
            }
            clientMutationId
        }
    }
`

class ActionsPopup extends Component {
    static contextType = CurrentUserContext;
    constructor(props) {
        super(props)
        this.state = {
            openModal: "",
            configurations: null,
            driverListDownloaded: false,
            loading: false,
            error: "",
            successMessage: false
        }
    }
    toggleModal = (modalName) => {
        this.setState({ openModal: this.state.openModal === modalName ? "" : modalName, driverListDownloaded: false, error: "", successMessage: false })
    }
    handleHideConfirm = (action) => {
        let bulkAction = action ? "HIDE_FROM_COLLECTIONS" : "UNHIDE_FROM_COLLECTIONS"
        if (this.props.allSelectedInList) {
            this.runBulkActions(bulkAction)
            return
        }
        this.toggleHideDrivers(action)
    };
    toggleHideDrivers = async (action) => {
        this.setState({ loading: true, successMessage: false })
        try {
            let selectedDrivers = this.props.selectedDrivers
            await Promise.all(
                selectedDrivers.map(item =>
                    this.updateDriver(item, { hideFromCollections: action })
                )
            )
            this.setState({ loading: false, successMessage: true })
            this.props.resetSelectedDrivers()
        } catch (error) {
            this.setState({ loading: false, error: error.toString() })
        }
    }
    updateDriver = (id, newvals) => {
        let input = {
            id: id,
            ...newvals
        }
        return this.props.update(input).then(result => { this.props.refetchQuery() })
    }
    unAssignDrivers = (assignmentCategory) => {
        this.setState({ loading: true, successMessage: false })
        let input = {
            drivers: this.props.selectedDrivers,
            assignmentCategory: assignmentCategory
        }
        this.props.apolloClient.mutate({
            mutation: RemoveDriverAssignmentMutation,
            variables: { input },
        }).then((result) => {
            this.setState({ loading: false, successMessage: true })
            this.props.refetchQuery()
        })
    };
    handleAutoChargeOffConfirm = () => {
        if (this.props.allSelectedInList) {
            this.runBulkActions("AUTO_CHARGE_OFF")
            return
        }

        this.updateAutoCharge(false)
    }
    handleAutoChargeOnConfirm = () => {
        if (this.props.allSelectedInList) {
            this.runBulkActions("AUTO_CHARGE_ON")
            return
        }

        this.updateAutoCharge(true)
    };
    runBulkActions = (action) => {
        this.setState({ loading: true, error: null, successMessage: false })
        let input = {
            filterValues: this.props.filterValues,
            action: action
        }
        this.props.apolloClient.mutate({
            mutation: runDriverBulkActionMutation,
            variables: { input }
        }).then(result => {
            const error = result.data?.runDriverBulkActionMutation?.errors?.length > 0 ? result.data?.runDriverBulkActionMutation?.errors[0].messages[0] : ""
            this.setState({ loading: false, error: error, successMessage: true })
            this.props.refetchQuery()
        }).catch(error => {
            this.setState({ loading: false, error: error.toString() })
        }).finally(() => {
            this.setState({ loading: false })

        })
    }
    updateAutoCharge = async (autoCharge) => {
        this.setState({ loading: true, error: null, successMessage: false })
        try {
            let selectedDrivers = this.props.selectedDrivers
            await Promise.all(selectedDrivers.map(id => this.updateDriver(id, { autoCharge })))
            this.setState({ loading: false, successMessage: true })
            this.props.resetSelectedDrivers()

        } catch (error) {
            this.setState({ loading: false, error: error.toString() })
        }
    }
    handleUnAssignConfirm = (assignmentCategory) => {
        let actionMap = {
            COLLECTOR: "UNASSIGN_COLLECTORS",
            SECONDARY_COLLECTOR: "UNASSIGN_SECONDARY_COLLECTORS",
            GENERAL: "UNASSIGN_COLLECTORS"
        }

        let action = actionMap[assignmentCategory]
        if (this.props.allSelectedInList) {
            this.runBulkActions(action, assignmentCategory)
            return
        }
        this.unAssignDrivers(assignmentCategory)
    };

    downloadDriverList = () => {
        this.setState({ loading: true, error: null, driverListDownloaded: false })
        let input = {
            filterValues: this.props.filterValues,
            config: this.props.columnConfig || []
        }

        if (!this.props.allSelectedInList && this.props.selectedDrivers?.length > 0) {
            input.selectedDrivers = this.props.selectedDrivers && this.props.selectedDrivers.length > 0 ? this.props.selectedDrivers : null
        }

        this.props.apolloClient.mutate({
            mutation: DownloadDriverListMutation,
            variables: { input }
        }).then(result => {
            const error = result.data?.downloadDriverList?.errors?.length > 0 ? result.data?.downloadDriverList?.errors[0].messages[0] : ""
            this.setState({ loading: false, error: error, driverListDownloaded: !error })
        }).catch(error => {
            this.setState({ loading: false, error: error.toString() })
        }).finally(() => {
            setTimeout(() => {
                this.setState({ error: "" })
            }, 5000)
        })
    }

    render() {
        const { selectedDrivers, activeTab, filterValues, allSelectedInList } = this.props
        const { currentUser } = this.context
        return (
            <>
                <a
                    id="viewActions"
                    className="driver-list-button"
                    onClick={() => this.toggleModal("viewActions")}
                >
                    ACTIONS | <i className="fa fa-cog" aria-hidden="true"></i>
                </a>
                <Popover trigger="legacy" placement="bottom" className="listing-action-items" target="viewActions" isOpen={this.state.openModal === "viewActions"} toggle={() => this.toggleModal("")}>
                    <PopoverBody>
                        <ul>
                            {activeTab === "Collections" && this.props.hasPermissions && this.props.hasPermissions.includes("custom_can_auto_charge") && !allSelectedInList && <li>
                                <a className="driver-list-button" onClick={() => this.toggleModal("WeeklyChargeModal")}>
                                    <i className="fa fa-dollar" aria-hidden="true"></i> | Weekly Charge
                                </a>
                                &nbsp;&nbsp;&nbsp;&nbsp;
                            </li>}
                            {selectedDrivers && selectedDrivers.length > 0 &&
                                <>
                                    <li>
                                        <a className="driver-list-button" onClick={() => this.toggleModal("autoChargeConfirmationOn")}>
                                            <i className="fa fa-money" aria-hidden="true"></i> | Auto Charge On
                                        </a>&nbsp;&nbsp;
                                    </li>
                                    <li>
                                        <a className="driver-list-button" onClick={() => this.toggleModal("autoChargeConfirmationOff")}>
                                            <i className="fa fa-money" aria-hidden="true"></i> | Auto Charge Off
                                        </a>&nbsp;&nbsp;
                                    </li>
                                    {activeTab === "Collections" && filterValues.hideFromCollections !== undefined && (filterValues.hideFromCollections === true ?
                                        this.props.hasPermissions && this.props.hasPermissions.includes("custom_can_unhide_collection") && <li>
                                            <a className="driver-list-button" onClick={() => this.toggleModal("unhideFromCollections")}>
                                                <i className="fa fa-eye" aria-hidden="true"></i> | Unhide From Collections
                                            </a>&nbsp;&nbsp;&nbsp;&nbsp;
                                        </li>
                                        : this.props.hasPermissions && this.props.hasPermissions.includes("custom_can_hide_collection") && <li> <a className="driver-list-button" onClick={() => this.toggleModal("hideFromCollections")}>
                                            <i className="fa fa-eye-slash" aria-hidden="true"></i> | Hide From Collections
                                        </a>&nbsp;&nbsp;&nbsp;&nbsp;
                                        </li>)
                                    }
                                    {["All Drivers", "Active Drivers", "Collections"].includes(activeTab) && this.props.hasPermissions && this.props.hasPermissions.includes("add_driverassignment") &&
                                        <>
                                            <li>
                                                <a className="driver-list-button" onClick={() => this.toggleModal("RepAssignmentModal")}>
                                                    <i className="fa fa-plus" aria-hidden="true"></i> | Assign {"Collections" === activeTab ? "Collectors" : "Reps"}
                                                </a>&nbsp;&nbsp;&nbsp;&nbsp;
                                            </li>
                                            <li>
                                                <a className="driver-list-button" onClick={() => this.toggleModal("unAssignReps")} >
                                                    <i className="fa fa-minus" aria-hidden="true"></i> | Unassign {"Collections" === activeTab ? "Collectors" : "Reps"}
                                                </a>&nbsp;&nbsp;&nbsp;&nbsp;
                                            </li>
                                        </>
                                    }
                                    {["Collections"].includes(activeTab) && this.props.hasPermissions && this.props.hasPermissions.includes("add_driverassignment") &&
                                        <li>
                                            <a className="driver-list-button" onClick={() => this.toggleModal("unAssignSecondaryCollectors")}>
                                                <i className="fa fa-minus" aria-hidden="true"></i> | Unassign Secondary Collectors
                                            </a>&nbsp;&nbsp;&nbsp;&nbsp;
                                        </li>
                                    }
                                </>
                            }
                            {activeTab !== "Schedules" && !allSelectedInList &&
                                <li>
                                    <a className="driver-list-button" onClick={() => this.toggleModal("MassMessageModal")}>
                                        <i className="fa fa-commenting-o" aria-hidden="true"></i> | Message Drivers
                                    </a>&nbsp;&nbsp;&nbsp;&nbsp;
                                </li>
                            }

                            {["All Drivers", "Active Drivers"].includes(activeTab) && this.props.selectedDrivers.length === 0 && < li >
                                <a className="driver-list-button" onClick={() => this.toggleModal("AddNewDriver")}>
                                    <i className="fa fa-plus" aria-hidden="true"></i> | New Driver
                                </a>&nbsp;&nbsp;&nbsp;&nbsp;
                            </li>}
                            {activeTab !== "Download List" && this.props.hasPermissions && this.props.hasPermissions.includes("custom_can_download_driver_list") &&
                                <li>
                                    <a className="driver-list-button" onClick={() => this.toggleModal("DownloadList")}>
                                        <i className="fa fa-download" aria-hidden="true"></i> | Download List
                                    </a>&nbsp;&nbsp;&nbsp;
                                </li>
                            }
                            {activeTab === "Schedules" && <li>
                                <a className="driver-list-button">
                                    No action found
                                </a>&nbsp;&nbsp;&nbsp;&nbsp;
                            </li>}
                        </ul>
                    </PopoverBody>
                </Popover >
                {this.state.openModal === "WeeklyChargeModal" &&
                    <WeeklyChargeModal
                        open={this.state.openModal === "WeeklyChargeModal"}
                        handleClose={() => this.toggleModal(false)}
                        currentUser={currentUser}
                        selectedDrivers={this.props.selectedDrivers}
                    />}
                {this.state.openModal === "autoChargeConfirmationOn" &&
                    <ConfirmationPopup
                        open={this.state.openModal === "autoChargeConfirmationOn"}
                        message={!this.state.successMessage ? "Are you sure you want to turn on auto charge for " + (this.props.allSelectedInList ? this.props.totalDriverCount : this.props.selectedDrivers.length) + " selected drivers?" : ""}
                        loading={this.state.loading}
                        handleClose={() => this.toggleModal("")}
                        action={"Yes"}
                        confirmAction={this.handleAutoChargeOnConfirm}
                        color="danger"
                        error={this.state.error ? this.state.error : ""}
                        success={this.state.successMessage ? "Auto Charge On Action Performed Successfully" : ""}
                    />}
                {this.state.openModal === "autoChargeConfirmationOff" &&
                    <ConfirmationPopup
                        open={this.state.openModal === "autoChargeConfirmationOff"}
                        message={!this.state.successMessage ? "Are you sure you want to turn off auto charge for " + (this.props.allSelectedInList ? this.props.totalDriverCount : this.props.selectedDrivers.length) + " selected drivers?" : ""}
                        loading={this.state.loading}
                        handleClose={() => this.toggleModal("")}
                        action={"Yes"}
                        confirmAction={this.handleAutoChargeOffConfirm}
                        color="danger"
                        error={this.state.error ? this.state.error : ""}
                        success={this.state.successMessage ? "Auto Charge Off Action Performed Successfully" : ""}
                    />}
                {this.state.openModal === "RepAssignmentModal" && <RepAssignmentModal
                    open={this.state.openModal === "RepAssignmentModal"}
                    title={"Assign " + (this.props.allSelectedInList ? this.props.totalDriverCount : this.props.selectedDrivers.length) + " Selected Drivers to Reps"}
                    drivers={this.props.selectedDrivers}
                    handleClose={() => this.toggleModal(false)}
                    refetchDrivers={this.props.refetchQuery}
                    group={this.props.activeTab === "Collections" ? "Collectors" : "Sales Team"}
                    assignmentCategory={this.props.activeTab === "Collections" ? ["COLLECTOR", "SECONDARY_COLLECTOR"] : ["GENERAL"]}
                    filterValues={this.props.allSelectedInList ? this.props.filterValues : null}
                />}
                {this.state.openModal === "unAssignReps" && this.props.selectedDrivers.length > 0 &&
                    <ConfirmationPopup
                        open={this.state.openModal === "unAssignReps"}
                        message={!this.state.successMessage ? "Are you sure you want to un-assign " + (this.props.allSelectedInList ? this.props.totalDriverCount : this.props.selectedDrivers?.length) + (this.props.activeTab === "Collections" ? " collectors?" : " reps?") : ""}
                        loading={this.state.loading}
                        handleClose={() => { this.setState({ error: "" }); this.toggleModal("") }}
                        action={"Un-assign"}
                        confirmAction={() => this.handleUnAssignConfirm(this.props.activeTab === "Collections" ? "COLLECTOR" : "GENERAL")}
                        color="primary"
                        success={this.state.successMessage ? "Un-assign Collector Action Performed Successfully" : ""}
                        error={this.state.error ? this.state.error : ""}
                    />}
                {this.state.openModal === "unAssignSecondaryCollectors" && this.props.selectedDrivers.length > 0 &&
                    <ConfirmationPopup
                        open={this.state.openModal === "unAssignSecondaryCollectors"}
                        message={!this.state.successMessage ? "Are you sure you want to un-assign " + (this.props.allSelectedInList ? this.props.totalDriverCount : this.props.selectedDrivers?.length) + " secondary collectors?" : ""}
                        loading={this.state.loading}
                        handleClose={() => { this.setState({ error: "" }); this.toggleModal("") }}
                        action={"Un-assign"}
                        confirmAction={() => this.handleUnAssignConfirm("SECONDARY_COLLECTOR")}
                        color="primary"
                        success={this.state.successMessage ? "Un-assign Secondary Collector Action Performed Successfully" : ""}
                        error={this.state.error ? this.state.error : ""}
                    />}
                {this.state.openModal === "DownloadList" && this.props.totalDriverCount > 0 &&
                    <ConfirmationPopup
                        open={this.state.openModal === "DownloadList"}
                        message={!this.state.driverListDownloaded && "Are you sure you want to download the list of " + (this.props.allSelectedInList ? this.props.totalDriverCount : (this.props.selectedDrivers.length || this.props.totalDriverCount || 0)) + " drivers to your email?"}
                        loading={this.state.loading}
                        handleClose={() => { this.setState({ error: "" }); this.toggleModal("") }}
                        action={"Send List to my email"}
                        confirmAction={this.downloadDriverList}
                        color="primary"
                        error={this.state.error ? this.state.error : ""}
                        success={this.state.driverListDownloaded && "List sent to your email."}
                    />}
                {this.state.openModal === "MassMessageModal" && <MassMessageModal handleClose={() => this.toggleModal("MassMessageModal")} open={this.state.openModal === "MassMessageModal"} drivers={this.props.selectedDrivers && this.props.selectedDrivers.length > 0 ? this.props.selectedDrivers : null} />}
                {this.state.openModal === "AddNewDriver" && <AddNewDriver handleClose={() => this.toggleModal("AddNewDriver")} open={this.state.openModal === "AddNewDriver"} />}
                {this.state.openModal === "hideFromCollections" &&
                    <ConfirmationPopup
                        open
                        message={!this.state.successMessage ? "Are you sure you want to hide " + (this.props.allSelectedInList ? this.props.totalDriverCount : this.props.selectedDrivers?.length) + " drivers from collections?" : ""}
                        loading={this.state.loading}
                        handleClose={() => this.toggleModal("")}
                        action="Yes"
                        confirmAction={() => this.handleHideConfirm(true)}
                        color="primary"
                        success={this.state.successMessage ? "Hide From Collections Action Performed Successfully" : ""}
                        error={this.state.error || ""}
                    />}
                {this.state.openModal === "unhideFromCollections" &&
                    <ConfirmationPopup
                        open
                        message={!this.state.successMessage ? "Are you sure you want to unhide " + (this.props.allSelectedInList ? this.props.totalDriverCount : this.props.selectedDrivers?.length) + " drivers from collections?" : ""}
                        loading={this.state.loading}
                        handleClose={() => this.toggleModal("")}
                        action="Yes"
                        confirmAction={() => this.handleHideConfirm(false)}
                        color="primary"
                        success={this.state.successMessage ? "Unhide From Collections Action Performed Successfully" : ""}
                        error={this.state.error || ""}
                    />}
            </>
        )
    }
}


//-----------------------------------
export default graphql(UpdateDriver, {
    props: ({ mutate }) => ({
        update: (input) => mutate({ variables: { input } }),
    }),
})(
    graphql(HasPermissionsQuery, {
        options: () => ({
            variables: {
                userPermissions: [
                    "custom_can_auto_charge",
                    "custom_can_unhide_collection",
                    "custom_can_hide_collection",
                    "add_driverassignment",
                    "custom_can_download_driver_list",
                ],
            },
        }),
        props: ({ data: { hasPermissions, loading, variables } }) => ({
            hasPermissions,
            loading,
            variables,
        }),
    })(withApolloClient(ActionsPopup))
)

